import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-heading font-black text-2xl text-white tracking-tight">
            BEYOND<span className="text-[#00B3B3]">CALCULUS</span>
          </div>
          <p className="mt-4 text-white/60 max-w-md text-sm leading-relaxed">{t.footer.tagline}</p>
          <p className="mt-6 font-mono text-xs text-white/40 tracking-widest">
            SAP · BUSINESS INTELLIGENCE · DATA ENGINEERING
          </p>
        </div>
        <div>
          <div className="font-mono text-xs text-white/40 tracking-widest mb-4">NAV</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="text-white/70 hover:text-[#00B3B3]">{t.nav.services}</Link></li>
            <li><Link to="/solutions" className="text-white/70 hover:text-[#00B3B3]">{t.nav.solutions}</Link></li>
            <li><Link to="/about" className="text-white/70 hover:text-[#00B3B3]">{t.nav.about}</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-[#00B3B3]">{t.nav.contact}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-xs text-white/40 tracking-widest mb-4">CONTACT</div>
          <a href="mailto:geral@beyond.com.pt" className="text-white/80 text-sm hover:text-[#00B3B3] inline-flex items-center gap-1">
            geral@beyond.com.pt <ArrowUpRight size={14} />
          </a>
          <p className="text-white/40 text-xs mt-3">Lisboa · Portugal</p>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-white/40 text-xs">© {year} BEYONDCALCULUS. {t.footer.rights}</p>
          <p className="font-mono text-[10px] text-white/30 tracking-widest">v1.0 · BUILT WITH PRECISION</p>
        </div>
      </div>
    </footer>
  );
}
